import { PropTypes } from "prop-types";
import {
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Typography,
} from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { useHistory } from "react-router-dom";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import { MediumAvatar } from "../../styles/materialUi/avatar";
import "./profileCard.scss";

const propTypes = {
  profileId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  location: PropTypes.string,
  profilePictureKey: PropTypes.string,
  cardPath: PropTypes.string.isRequired,
  line1: PropTypes.string,
  line2: PropTypes.string,
};

const defaultProps = {
  location: "",
  profilePictureKey: "",
  line1: "",
  line2: "",
};

const ProfileCard = ({
  profileId,
  name,
  location,
  profilePictureKey,
  cardPath,
  line1,
  line2,
}) => {
  const history = useHistory();
  const handleOnClick = () => {
    history.push(cardPath);
  };

  return (
    <Card variant="outlined" className="profile-card">
      <CardActionArea onClick={handleOnClick}>
        <CardContent>
          <ProfilePicture
            profileId={profileId}
            avatar={MediumAvatar}
            editable={false}
            objectKey={profilePictureKey}
            alt={name}
          />
          <Typography variant="h6" className="name">
            {name}
          </Typography>
          <Typography noWrap variant="subtitle2">
            {line1}
          </Typography>
          <Typography noWrap variant="subtitle2">
            {line2}
          </Typography>
          <Chip
            className={location ? "location" : "location-hide"}
            variant="outlined"
            icon={<LocationOnOutlinedIcon />}
            label={location}
          />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

ProfileCard.propTypes = propTypes;
ProfileCard.defaultProps = defaultProps;

export default ProfileCard;
